import { useEffect, useRef, useState } from 'react';

// Tracks whether a container-query-collapsed label is hidden so a tooltip can stand in; mirrors the sentinel's display.
export const useCollapsibleLabel = <
  O extends HTMLElement = HTMLElement,
  S extends HTMLElement = HTMLElement,
>() => {
  const observeRef = useRef<O>(null);
  const sentinelRef = useRef<S>(null);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const observed = observeRef.current;
    const sentinel = sentinelRef.current;
    if (!observed || !sentinel) return;
    const update = () => setIsHidden(getComputedStyle(sentinel).display === 'none');
    update();
    const ro = new ResizeObserver(update);
    ro.observe(observed);
    return () => ro.disconnect();
  }, []);

  return { observeRef, sentinelRef, isHidden };
};
